import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {CustomToastrComponent} from "@shared/components/custom-toastr/custom-toastr.component";

@Injectable({
  providedIn: 'root'
})
export class ToastrService {

  timerDuration: number = 3000;

  constructor(private _snackBar: MatSnackBar) {}

  success(description: string, title: string) {
    this._snackBar.openFromComponent(CustomToastrComponent, {
      data: { title, description, type : 'success' },
      duration: this.timerDuration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
    });
  }

  error(description: string, title: string) {
    this._snackBar.openFromComponent(CustomToastrComponent, {
      data: { title, description, type : 'error' },
      duration: this.timerDuration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
    });
  }

  info(description: string, title: string) {
    this._snackBar.openFromComponent(CustomToastrComponent, {
      data: { title, description, type : 'info' },
      duration: this.timerDuration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
    });
  }

}
